export default __webpack_public_path__ + "static/media/edit.1d5ec6dc.svg";